export class User {
    Office:Office;
    OfficeId:number;
    RoleId:string;
    RoleName:string;
    KHB_UserId:number;
    UserName:string;
    Password:string;
    oldPassword :string;
    confirmPassword:string;
    NewPassword : string;
}

export class Register {
    // UserName:string;
    FirstName:string;
    LastName:string;
    PhoneNumber:number;
    Address:any;
    Email:string;
    District:string;
    State:string;
    Password:string;
}

export class Login {
    UserName:string;
    Password:string;
}
export class Office {
    OfficeId:number;
    OfficeCode:string;
    OfficeName:string;
    OfficeType:string;
    Address:string;
    pincode:string;
    TinNo:string;
    Email:string;
    PhoneNumber:number;
}

export class Search{
    SearchCriteria:string;
    SearchText:string;
    SearchRows:number;
}

export class Password{
    oldPassword:any;
    NewPassword:any;
    confirmPassword:any;
}

export class Application{
    ApplicationNo:any;
    FormType:any;
    PropertyType:any;
    ApplicantImage:any;
    DistrictCode:any;
    DistrictName:string;
    ProjectPlace:string;
    NotificationNo:any;
    ApplicantName:string;
    DateofBirth:any;
    Age:any;
    Gender:any;
    GuardianName:any;
    Address:any;
    TelephoneNumber:any;
    MobileNumber:any;
    Email:any;
    Category:any;
    AnnualIncome:any;
    ItPanNo:any;
    BankName:any;
    AccountNumber:any;
    IFSCCode:any;
    SiteDetails:any;
}




// WEBPACK FOOTER //
// ./src/app/shared/user.model.ts